var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-menu-column"},[(!_vm.isMobile)?_vm._t("default"):_c('component-menu-tree-node',{attrs:{"item":_vm.item,"references":_vm.references}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }